import React from 'react';
import PropTypes from 'prop-types';

import './scss/regionPanel.scss';

const RegionPanel = ({ region, version }) => {
  return region.length > 0 && (
    <div className="region-panel">
      <table>
        <tbody>
          <tr>
            <td>Region:</td>
            <td>{ region }</td>
          </tr>

          <tr>
            <td>Build:</td>
            <td>{ version }</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

RegionPanel.propTypes = {
  region: PropTypes.string.isRequired,
  version: PropTypes.string.isRequired,
};

export default RegionPanel;



// WEBPACK FOOTER //
// ./src/components/QbTabs/components/RegionPanel.js